import { render, staticRenderFns } from "./OnboardingTabFinish.vue?vue&type=template&id=5c6f8e16"
import script from "./OnboardingTabFinish.vue?vue&type=script&lang=ts&setup=true"
export * from "./OnboardingTabFinish.vue?vue&type=script&lang=ts&setup=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports